import { Divider, Drawer, Space } from '@mantine/core'

import useSidebar from '../hooks/useSidebar'
import Accordion from './Accordion'
import LogoutButton from './LogoutButton'

const accordionItems = [
  {
    value: 'TOP',
    description: '/dashboard/info',
  },
  {
    value: 'アナリティクス',
    description: [
      {
        value: '来店分析',
        description: [
          {
            value: 'アプリユーザ来訪分析',
            description: '/dashboard/analytics/visit/app-user',
          },
        ],
      },
      {
        value: '施策分析',
        description: [
          {
            value: 'チェックイン通知分析',
            description: '/dashboard/analytics/measure/check-in-notification',
          },
          {
            value: 'チェックインスタンプ分析',
            description: '/dashboard/analytics/measure/check-in-stamp',
          },
        ],
      },
    ],
  },
]

function Sidebar() {
  const { opened, close } = useSidebar()

  return (
    // <Drawer.Root size='25%' opened={opened} onClose={close}>
    // サイドメニュー幅広すぎ問題を修正するため、sizeをxsに変更
    <Drawer.Root size='xs' opened={opened} onClose={close}>
      <Drawer.Overlay />
      <Drawer.Content>
        <Drawer.Body className='py-4 pr-4 h-screen bg-[#001E61] text-white font-semibold flex flex-col justify-between'>
          <div>
            <Space h={64} />
            <Accordion items={accordionItems} />
          </div>
          <div>
            <Divider color='white' my='md' />
            <div className='pl-4'>
              <LogoutButton />
            </div>
          </div>
        </Drawer.Body>
      </Drawer.Content>
    </Drawer.Root>
  )
}

export default Sidebar
